<form (keydown.enter)="$event.preventDefault()" [formGroup]="detailForm">
  <div class="row" id="edit-form-search-cp">
    <div class="col-md-12">
      <ng-container *ngIf="!_noDirect else noDirect">
        <div class="row">
          <div class="col-9 col-sm-9 col-md-8 pr-0">
            <div class="mb-3 position-relative">
              <input #googleAutocompleteEditCp
                     (focusout)="reset($event)"
                     (keydown.enter)="$event.preventDefault()"
                     autocomplete="off"
                     class="form-control"
                     formControlName="address1"
                     id="edit_street_number_cp"
                     placeholder="Enter your address"
                     style="margin-left: 10px"/>
              <dp-field-error [formField]="form['address1']"></dp-field-error>
            </div>
          </div>
          <div class="col-9 col-sm-3 col-md-4">
            <div class="mb-3 position-relative  text-right" style="padding-top: 1px;">
              <button (click)="enableManualInput()" [ngClass]="{'customer-detail': _isCustomerDetailPage}"
                      class="btn btn-dark btn-reset"
                      style="padding: 7px 2px;"
                      type="button">Direct Input
              </button>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-template #noDirect>
        <input #googleAutocompleteEditCp style="display: none;">

      </ng-template>
    </div>
  </div>

  <div class="row" id="edit-form-result-cp">
    <div class="col-md-12">
      <div class="row">
        <div class="col-9 col-sm-9 col-md-9 pr-0">
          <div class="mb-3 position-relative">
            <input [ngClass]="{'form-control-gray': isReadOnly}"
                   [readonly]="isReadOnly"
                   autocomplete="off"
                   class="form-control"
                   formControlName="address1"
                   id="edit_route_cp"
                   placeholder="Address1"
                   style="margin-left: 10px"/>
            <dp-field-error [formField]="form['address1']"></dp-field-error>
          </div>
        </div>
        <div class="col-9 col-sm-3 col-md-3">
          <div class="mb-3 position-relative  text-right">
            <button (click)="addressEdit()" [disabled]="_disabled"
                    class="btn btn-dark btn-reset" type="button">Reset
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12">
        <div class="mb-3 position-relative">
          <input autocomplete="off"
                 class="form-control"
                 formControlName="address2"
                 id="edit_address2_cp"
                 placeholder="Address2"
          />
          <dp-field-error [formField]="form['address2']"></dp-field-error>
        </div>
      </div>
    </div>
    <div class="col-md-5">
      <div class="mb-3 position-relative">
        <input [ngClass]="{'form-control-gray': isReadOnly}"
               [readonly]="isReadOnly"
               autocomplete="off"
               class="form-control"
               formControlName="city"
               id="edit_locality_cp"
               placeholder="City"
        />
        <dp-field-error [formField]="form['city']"></dp-field-error>
      </div>
    </div>
    <div class="col-md-2">
      <div class="mb-3 position-relative">
        <input [ngClass]="{'form-control-gray': isReadOnly}"
               [readonly]="isReadOnly"
               autocomplete="off"
               class="form-control"
               formControlName="state"
               id="edit_administrative_area_level_1_cp"
               maxlength="2"
               placeholder="State"/>
        <dp-field-error [formField]="form['state']"></dp-field-error>
      </div>
    </div>
    <div class="col-md-3">
      <div class="mb-3 position-relative">
        <input [attr.maxlength]="this.isSECA? 7 : 5"
               [ngClass]="{'form-control-gray': isReadOnly}"
               [readonly]="isReadOnly"
               autocomplete="off"
               class="form-control"
               formControlName="zipcode"
               id="edit_postal_code_cp"
               placeholder="Zipcode"/>
        <dp-field-error [formField]="form['zipcode']"></dp-field-error>
      </div>
    </div>
    <div class="col-md-2">
      <div class="mb-3 position-relative">
        <input [ngClass]="{'form-control-gray': isReadOnly}"
               [readonly]="isReadOnly"
               autocomplete="off"
               class="form-control"
               formControlName="country"
               id="edit_country_cp"
               maxlength="2"
               placeholder="Country"/>
        <dp-field-error [formField]="form['country']"></dp-field-error>
      </div>
    </div>
  </div>
</form>
